<template>
  <div class="form-group">
    <label>{{ translate('comments.text_comment') }}</label>
    <textarea
        ref="comment"
        v-model="data"
        rows="5"
        class="form-control border-input comment"
        :placeholder="translate('comments.text_comment')"
        @input="change"
    >

    </textarea>
    <div ref="pasteCatcher"
         contenteditable="true"
         @paste="onPasteFromCE"
         style="position:absolute; left:-9999px; width:1px; height:1px; overflow:hidden;"></div>
  </div>
</template>
<script>

export default {
  name: "TextAreaImage",
  props: [
      'value'
  ],
  data () {
    return {
      data: ""
    }
  },

  mounted() {
    const comment = this.$refs.comment;
    const pasteCatcher = this.$refs.pasteCatcher;

    comment.addEventListener('paste', this.onPasteFromTextarea);

    this._onKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'v') {
        if (pasteCatcher) pasteCatcher.focus();
      }
    };
    comment.addEventListener('keydown', this._onKeyDown, { passive: true });

    this.data = this.value ? this.value : ""
  },

  beforeUnmount() {
    const ta = this.$refs.comment;
    ta?.removeEventListener('keydown', this._onKeyDown);
    ta?.removeEventListener('paste', this.onPasteFromTextarea);
  },

  methods: {
    change () {
      this.$emit("input", this.data)
    },

    _hasTextInClipboard (e) {
      const cd = e.clipboardData
      if (!cd || !cd.getData) return false

      const plain = cd.getData('text/plain')
      return (plain)
    },

    async onPasteFromTextarea (e) {
      if (this._hasTextInClipboard(e)) {
        return
      }

      const files = this._extractFilesFromEvent(e)
      if (files.length) {
        e.preventDefault()
        this._uploadMany(files)
        return
      }

      if (navigator.clipboard && navigator.clipboard.read) {
        try {
          const more = await this._readImagesFromClipboardAPI()
          if (more.length) this._uploadMany(more)
        } catch (err) {
          console.warn('clipboard.read failed:', err)
        }
      }
    },

    async onPasteFromCE (e) {
      if (!this._hasTextInClipboard(e)) {
        const files = this._extractFilesFromEvent(e)
        if (files.length) {
          e.preventDefault()
          this.$refs.pasteCatcher.innerHTML = ''
          await this._uploadMany(files)
        }
      }

      this.$refs.comment && this.$refs.comment.focus()
    },

    _extractFilesFromEvent (e) {
      const out = []
      const cd = e.clipboardData
      if (!cd) return out

      if (cd.items && cd.items.length) {
        for (const it of cd.items) {
          if (it.kind === 'file') {
            const f = it.getAsFile()
            if (f) out.push(f)
          }
        }
      }
      if (!out.length && cd.files && cd.files.length) {
        for (const f of cd.files) out.push(f)
      }
      return out
    },

    async _readImagesFromClipboardAPI () {
      const out = []
      const items = await navigator.clipboard.read()
      for (const it of items) {
        for (const t of it.types) {
          if (t.startsWith('image/')) {
            const blob = await it.getType(t)
            out.push(new File(
                [blob],
                `pasted-${Date.now()}.${t.split('/')[1] || 'png'}`,
                { type: t }
            ))
          }
        }
      }
      return out
    },

    async _uploadMany (files) {
      for (const file of files) {
        try {
          const resp = await this.uploadFile(file)
          this.$emit('file-uploaded', { file, resp })
        } catch (e) {
          console.error('Upload failed:', e)
        }
      }
    },

    uploadFile (file) {
      const formData = new FormData()
      formData.append('file', file)

      this.$http.v1.attachmentsImage(formData, (response) => {
        this.data += `\n[[~${response.data.url}]]\n`
        this.change()
      })
    }
  }
}
</script>
